import { EntityDescriptor } from "@crispico/foundation-react";
import { TotalQuantityFieldDescriptor } from "../TotalQuantityFieldDescriptor";
import { FieldType } from "@crispico/foundation-react/entity_crud/FieldType";

export class InvoiceDataEntityDescriptor extends EntityDescriptor {
    constructor() {
        super({
            name: "InvoiceData",
            icon: "file text",
            defaultSort: [{ field: "date", direction: "ASC" }],
        });
    }

    protected customize() {
        this.addFieldDescriptor({ name: "debords", type: FieldType.number });
        this.addFieldDescriptor({ name: "quantity", type: FieldType.number });
        this.addFieldDescriptor({ name: "totalPrice", type: FieldType.number });
        this.addFieldDescriptor({ name: "pricePerUnit", type: FieldType.number });
        this.addFieldDescriptor({ name: "nightDifference", type: FieldType.number });
        this.addFieldDescriptor({ name: "weekendDifference", type: FieldType.number });
        this.addFieldDescriptor({ name: "totalQuantity" }, new TotalQuantityFieldDescriptor());
        this.isInDefaultColumnConfig(true, "date", "name", "auxiliarInfo", "priceUnitType", "resourceType", "debords", "quantity", "totalQuantity", "pricePerUnit", "nightDifference", "weekendDifference", "totalPrice");
    }
}
